import { InjectionToken } from "@angular/core";

export type SidePanelData<T = undefined> = {
  data: T;
};

export const SIDE_PANEL_DATA = new InjectionToken('side-panel-data')
